module.exports = __webpack_public_path__ + "static/media/microphone_clip_on.f621c3b5.svg";